/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PmGetMagnetType$Params {
  modality: string;
  systemSerialNumber: string;
  systemMaterialNumber: number;
}

export function pmGetMagnetType(http: HttpClient, rootUrl: string, params: PmGetMagnetType$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, pmGetMagnetType.PATH, 'get');
  if (params) {
    rb.path('modality', params.modality, {});
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
pmGetMagnetType.PATH = '/api/PatternMatch/magnetType/{modality}/{systemSerialNumber}/{systemMaterialNumber}';
pmGetMagnetType.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
pmGetMagnetType.ROOTURL = '/patternmatch';
